import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { acceptInvite } from '../services/authService';
import toast from 'react-hot-toast';

const InvitePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = new URLSearchParams(location.search).get('token');
    if (token) {
      navigate(`/register?token=${token}`);
    } else {
      navigate('/');
    }
  }, [location, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <div className="card">Перенаправление...</div>
    </div>
  );
};

export default InvitePage;